
<nav *ngIf=" currentRoute !=='/login' && currentRoute !=='/'"
  class="navbar navbar-expand-lg navbar-light bg-light py-0 px-1"
  style="font-size: 14px; font-weight: 500"
>
  <a class="navbar-brand pointer-cursor"
  (click)="open('/Admin/Dashboard')"
  >
    <span class="navbar-brand mb-0 h1">Perfect Learning</span>
  </a>
  <div
    class="collapse navbar-collapse"
    id="navbarNavDropdown"
    style="font-size: 14px; font-weight: 500"
  >
    <ul class="navbar-nav">
      <li class="nav-item dropdown" *ngIf="Role == 'SA' || Role == 'SME'">
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Subject
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a [routerLink]="['/subject']" class="dropdown-item">Add/Edit Topic
          </a>
          <a [routerLink]="['/Subject/Resources']" class="dropdown-item"
            >Resource Assignment list</a
          >
        </div>
      </li>
      <li
        class="nav-item dropdown"
        *ngIf="(Role == 'SA' || Role == 'SME' || Role == 'CW') && this.courseId"
      >
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Content
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a
            (click)="open('Content/StudyUnitReport','Report')"
            class="dropdown-item"
            role="button"
            >Study Unit Report</a
          >
          <a
            (click)="open('Content/MainTopics','Main Topics')"
            class="dropdown-item"
            role="button"
            >
          Course Main Topics
          </a>
          <a
            (click)="open('Content/add/edit','STUDY UNIT')"
            class="dropdown-item"
            role="button"
            >Add/Edit Study Unit (Module /Lesson)</a
          >
          <a
          (click)="open('Content/DisplayOrder','Display Order')"
          class="dropdown-item"
          role="button"
          >Study Unit (Module /Lesson) Display Order</a
        >
          <hr class="dropdown-divider" />
          <a
          (click)="open('Content/Clone','CLONE')"
          class="dropdown-item"
          role="button"
          >
          Clone Study Unit and Study Material
          </a
        >
          <hr class="dropdown-divider" />

          <a
            (click)="open('Content/content','STUDY UNIT2')"
            class="dropdown-item"
            role="button"
            >Add/Edit Study Material</a
          >

          <a
          (click)="open('Content/status/WIP','WIP')"
          class="dropdown-item"
          role="button"
            >WIP</a
          >
          <a
          (click)="open('Content/status/Approved','Approved')"
            class="dropdown-item"
            role="button"
            >Approved</a
          >
          <a
          (click)="open('Content/status/Defer', 'Defer')"
          class="dropdown-item"
          role="button"
          >Deferred</a
        >
        <a
          (click)="open('Content/status/Rejected', 'Rejected')"
          class="dropdown-item"
          role="button"
          >Rejected</a
        >
        <a
          (click)="open('Content/status/Rework', 'Rework')"
          class="dropdown-item"
          role="button"
          >Rework</a
        >
        <a
          (click)="open('Content/status/Under Review', 'Under Review')"
          class="dropdown-item"
          role="button"
          >Under Review</a
        >
        <a
          (click)="open('Content/status/Submitted', 'Submitted')"
          class="dropdown-item"
          role="button"
          >Submitted</a
        >
        </div>
      </li>
      <li
        class="nav-item dropdown"
        *ngIf="Role == 'SA' || Role == 'SME' || Role == 'CW'"
      >
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Question
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a
          (click)="open('questionmaster/add/edit','SUBJECT BREAKDOWN')"
            class="dropdown-item"
            role="button"
            >Add/Edit Question</a
          >
          <hr class="dropdown-divider" />
          <a
          (click)="open('questionmaster/question','SUBJECT BREAKDOWN')"
            class="dropdown-item"
            role="button"
            >All Questions</a
          >
          <a
            (click)="open('questionmaster/questionstatus/WIP','WIP')"
            class="dropdown-item"
            role="button"
            >WIP</a>
          <a
            (click)="open('questionmaster/questionstatus/Approved','Approved')"
            class="dropdown-item"
            role="button"
            >Approved</a
          >
          <a
            (click)="open('questionmaster/questionstatus/Defer','Defer')"
            class="dropdown-item"
            role="button"
            >Deferred</a
          >
          <a
          (click)="open('questionmaster/questionstatus/Rejected','Rejected')"
            class="dropdown-item"
            role="button"
            >Rejected</a
          >
          <a
            (click)="open('questionmaster/questionstatus/Rework','Rework')"
            class="dropdown-item"
            role="button"
            >Rework</a
          >
          <a
          (click)="open('questionmaster/questionstatus/Submitted','Submitted')"
            class="dropdown-item"
            role="button"
            >Submitted</a>
        </div>
      </li>
      <li
        class="nav-item dropdown"
        *ngIf="Role == 'SA' || Role == 'SME' || Role == 'CW'"
      >
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
        Flash Card
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a
            (click)="open('fa/questionmaster/add/edit','SUBJECT BREAKDOWN')"
            class="dropdown-item"
            role="button"
            >Add/Edit Flash Card</a
          >
          <hr class="dropdown-divider" />
          <a
          (click)="open('fa/questionmaster/question','SUBJECT BREAKDOWN')"
            class="dropdown-item"
            role="button"
            >All Flash Card</a
          >
          <a
            (click)="open('fa/questionmaster/questionstatus/WIP','WIP')"
            class="dropdown-item"
            role="button"
            >WIP</a
          >
          <a
            (click)="open('fa/questionmaster/questionstatus/Approved','Approved')"
            class="dropdown-item"
            role="button"
            >Approved</a
          >
          <a
          (click)="open('fa/questionmaster/questionstatus/Defer','Defer')"
            class="dropdown-item"
            role="button"
            >Deferred</a
          >
          <a
            (click)="open('fa/questionmaster/questionstatus/Rejected','Rejected')"
            class="dropdown-item"
            role="button"
            >Rejected</a
          >
          <a
          (click)="open('fa/questionmaster/questionstatus/Rework','Rework')"
            class="dropdown-item"
            role="button"
            >Rework</a
          >
          <a
          (click)="open('fa/questionmaster/questionstatus/Submitted','Submitted')"
            role="button"
            class="dropdown-item"
            >Submitted</a
          >
        </div>
      </li>
      <li class="nav-item dropdown" *ngIf="Role == 'SA' || Role == 'SME'">
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          User
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a
          [routerLink]="['User/Poweruserlist']"
          class="dropdown-item"
          role="button"
            >User</a
          >
        </div>
      </li>
      <li class="nav-item dropdown" *ngIf="Role == 'SA' || Role == 'SME'">
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Courses
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a [routerLink]="['Exam/ExamAgencies']"role="button"
           class="dropdown-item"

            >Exam Agencies</a
          >
          <a [routerLink]="['/Notifications']" class="dropdown-item"
            >Notifications</a
          >
          <a (click)="open('Exam/WeeklyPracticeTests','')" class="dropdown-item" role="button"
            >
            Practice Tests
          </a>
          <a (click)="open('Exam/MockExams','')" class="dropdown-item" role="button"
            >Mock Exams</a>
          <a (click)="open('Exam/StudyUnit/PracticeTest','')" class="dropdown-item" role="button"
            >Study Unit Practice Test</a>
        </div>
      </li>

      <li class="nav-item dropdown" *ngIf="Role == 'SA' || Role == 'SME'">
        <a
          class="nav-link dropdown-toggle"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Reports
        </a>
        <ul class="dropdown-menu">
          <li class="nav-item dropend">
            <a
              class="dropdown-item dropdown-toggle py-1"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Subject
            </a>
            <!-- <ul class="dropdown-menu"></ul> -->
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li class="nav-item dropend">
            <a
              class="dropdown-item dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Content
            </a>
            <ul class="dropdown-menu">
              <a
                [routerLink]="['Content/report/', 'STUDY UNIT']"
                class="dropdown-item"
                role="button"
                >Study Material Report</a
              >
              <a
                [routerLink]="['Content/report/StudyUnit/', 'STUDY UNIT']"
                class="dropdown-item"
                role="button"
                >Study Unit Report</a
              >
            </ul>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li class="nav-item dropend">
            <a
              class="dropdown-item dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Question
            </a>
            <ul class="dropdown-menu">
              <a [routerLink]="['Question/report']"
               class="dropdown-item"
               role="button"
                >Question Monthly Count</a
              >
              <a
                [routerLink]="['Question/deferredreport']"
                class="dropdown-item"
                role="button"
                >Deferred Questions</a
              >
              <a
                [routerLink]="['Question/validate-external-references']"
                class="dropdown-item"
                role="button"
                >Validate External references in question</a
              >
            </ul>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li class="nav-item dropend">
            <a
              class="dropdown-item dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Flash Card
            </a>
            <ul class="dropdown-menu">
              <a
                [routerLink]="['fa/Question/validate-external-references']"
                class="dropdown-item"
                role="button"
                >Validate External references in Flashcard</a
              >
            </ul>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li class="nav-item dropend">
            <a
              class="dropdown-item dropdown-toggle"
              role="button"

              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              User
            </a>
            <!-- <ul class="dropdown-menu"></ul> -->
            <!-- <ul class="dropdown-menu"> -->
            <!-- <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li> -->
            <!-- </ul> -->
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li class="nav-item dropend">
            <a
              class="dropdown-item dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Exam
            </a>
            <!-- <ul class="dropdown-menu"></ul> -->
            <!-- <ul class="dropdown-menu"> -->
            <!-- <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li> -->
            <!-- </ul> -->
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown" *ngIf="Role == 'SA' || Role == 'SME'">
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Student
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a [routerLink]="['/students']" class="dropdown-item"
          role="button"
            >Student</a
          >
        </div>
      </li>
      <li class="nav-item dropdown" *ngIf="Role == 'SA' || Role == 'SME'">
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Schools
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a [routerLink]="['/schools']" class="dropdown-item" role="button"
            >School</a
          >
        </div>
      </li>
    </ul>
  </div>
  <div class="dashboard-app">
    <header class="dashboard-toolbar">
      <!-- <a class="menu-toggle">
        <i class="fa fa-bars">
        </i></a> -->
      <button
        type="button"
        class="btn btn-light btn-sm menubtnBG"
        data-toggle="tooltip"
        title="sign out"
        (click)="clickSignout()"
      >
        <i class="fal fa-sign-out-alt" name="sign-out"></i> SignOut
      </button>
    </header>
  </div>
</nav>

<!-- </div> -->

<div class="dashboard-content px-0">
  <div class="container" style="overflow: hidden">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- </div> -->
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="signOutflag"
>
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">SignOut</h6>
        <button
          type="button"
          class="close"
          style="padding-right: 20px; font-size: 30px; outline: 0"
          (click)="clickSignout()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Would you like to signout ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bl-btn"
                  (click)="signOut()"
                >
                  SignOut
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="clickSignout()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075;z-index:99999"
  *ngIf="SessionPopup"

>
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Session Expired</h6>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Your Session has been Expired.</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bl-btn"
                  (click)="sessionOut()"
                >
                  Back To Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
